import { render, staticRenderFns } from "./CompanyPrecification.vue?vue&type=template&id=0d00141e"
import script from "./CompanyPrecification.vue?vue&type=script&lang=js"
export * from "./CompanyPrecification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports